const getDefaultWindow = () => (typeof window !== 'undefined' ? window : null);

const DEFAULT_ROLE_WISE_ROUTES = {
  agent: [],
  administrator: [],
};

let currentRoleWiseRoutes = { ...DEFAULT_ROLE_WISE_ROUTES };

const cloneRouteMap = (routeMap = {}) => {
  return Object.keys({ ...DEFAULT_ROLE_WISE_ROUTES, ...routeMap }).reduce(
    (acc, role) => {
      acc[role] = Array.isArray(routeMap?.[role]) ? [...routeMap[role]] : [];
      return acc;
    },
    {}
  );
};

const appendRouteForRole = (routeMap, role, routeName) => {
  if (!role || !routeName) return;
  if (!Array.isArray(routeMap[role])) {
    routeMap[role] = [];
  }
  routeMap[role].push(routeName);
};

export const buildRoleWiseRoutes = (
  routes = [],
  seed = DEFAULT_ROLE_WISE_ROUTES
) => {
  const routeMap = cloneRouteMap(seed);

  const visitRoutes = (routeList = []) => {
    if (!Array.isArray(routeList)) return;

    routeList.forEach((route) => {
      if (!route) return;

      visitRoutes(route.children);

      if (!Array.isArray(route.roles)) return;
      route.roles.forEach((role) =>
        appendRouteForRole(routeMap, role, route.name)
      );
    });
  };

  visitRoutes(routes);
  return routeMap;
};

export const setRoleWiseRoutes = (
  routeMap,
  { windowObject = getDefaultWindow() } = {}
) => {
  currentRoleWiseRoutes = cloneRouteMap(routeMap);

  try {
    if (windowObject) {
      windowObject.roleWiseRoutes = currentRoleWiseRoutes;
    }
  } catch {
    // Keep the in-memory fallback when globals are read-only.
  }

  return currentRoleWiseRoutes;
};

export const getRoleWiseRoutes = ({
  windowObject = getDefaultWindow(),
} = {}) => {
  try {
    return windowObject?.roleWiseRoutes || currentRoleWiseRoutes;
  } catch {
    return currentRoleWiseRoutes;
  }
};

export const getRoutesForRole = (role, options = {}) => {
  const routeMap = getRoleWiseRoutes(options);
  return Array.isArray(routeMap?.[role]) ? routeMap[role] : [];
};

export const isRouteAvailableForRole = (routeName, role, options = {}) => {
  return getRoutesForRole(role, options).includes(routeName);
};
